export enum enumDocumentState {
  CREATED,
  UPLOADED,
  SCAN_PENDING,
  SCAN_FAILED,
  DELETED,
  FILE_SIZE_TO_BIG_AFTER_SCAN,
}
